// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__V6f9D","row":"ProcedureTreatmentSummary_row__1S3X3"};